import React, { Component, useEffect, useState } from 'react'
import { authActions } from '../../store/actions'
import { connect } from 'react-redux'
import Input from '../../module/input'
import history from '../../route/history'

const PasswordConfirmModal = (props) => {
  const queryString = require('query-string')

  const [passwd, setPasswd] = useState('')
  const [state, setState] = useState({})

  /**
   * 비밀번호 재확인 (Step-up).
   *
   * 서버사이드 step-up 인증 도입(2026-05-18) 후 동작:
   *   - 응답 body를 신뢰하지 않는다. HTTP status로만 분기한다.
   *   - 200 → 서버가 인증 시각을 기록. 모달 닫고 라우팅.
   *   - 4xx → axios가 reject. catch로 빠지고 에러 메시지 노출. 라우팅 안 함.
   *
   * 이전에는 응답 payload(boolean)을 직접 보고 분기했으나,
   * 프록시로 응답 본문을 변조해 우회할 수 있는 취약점이 있었다.
   * 이제 권한 정보는 서버 메모리에만 존재하므로 우회 불가.
   */
  const goNext = async () => {
    if (passwd?.length <= 0) {
      setState({
        ...state,
        errMessage: '비밀번호를 입력해주세요.',
      });
      return;
    }

    try {
      // 200이면 axios resolve. response.status로 명시적으로 한 번 더 검증한다.
      // (이론상 axios가 2xx만 resolve로 보내지만, 다른 곳의 인터셉터·validateStatus 설정이
      //  바뀐 경우의 안전망 + 디버깅용.)
      const response = await props.checkPwd(passwd);
      const httpStatus = response?.status;

      if (httpStatus >= 200 && httpStatus < 300) {
        // 정상 처리: 메시지 잔존 방지를 위해 errMessage를 비우고 모달 닫기 → 라우팅.
        setState({ errMessage: '' });
        props.showPwdPopup(false, '', '');
        if (props.requestType === 'link' && props.value) {
          history.replace(props.value);
        }
        return;
      }

      // 여기에 도달하는 케이스는 axios가 비-2xx를 resolve로 처리한 비정상 상황.
      // 어떤 응답인지 콘솔에 남겨 원인 파악을 돕는다.
      // (참고: 사용자가 "200인데 불일치 멘트가 보인다"고 보고한 케이스의 진단 채널)
      console.warn('[step-up] resolved with non-2xx status:', httpStatus, response);
      setState({
        ...state,
        errMessage: '비밀번호가 일치하지 않습니다.',
      });
    } catch (error) {
      // 401(비밀번호 불일치)·기타 4xx·네트워크 오류 모두 여기로.
      // 디버깅용: 어떤 status로 catch에 도달했는지 콘솔에 남긴다.
      const errStatus = error?.response?.status;
      console.warn('[step-up] checkPwd rejected. status=', errStatus, error);

      if (errStatus === 401) {
        // 정상적인 비밀번호 불일치.
        setState({
          ...state,
          errMessage: '비밀번호가 일치하지 않습니다.',
        });
      } else {
        // 그 외 케이스(네트워크 오류, 5xx, 응답 객체 누락 등)는 일반 오류 메시지로 노출.
        // → "200인데 불일치 멘트"가 보인다면 이 분기일 가능성이 높음.
        setState({
          ...state,
          errMessage: '오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
        });
      }
    }
  }

  const handleChange = (e) => {
    const { value } = e.target
    setPasswd(value)
  }

  return (
    <React.Fragment>
      <React.Fragment>
                <div className="alert-wrap">
                  <div className="alert-box">
                    <p>패스워드 인증</p>
                    <br />
                      <div className="modal-body">
                        <Input
                          type="password"
                          className="form-control input-text m-b-20"
                          placeholder="비밀번호"
                          id="passwd"
                          name="passwd"
                          onChange={handleChange}
                          value={passwd || ''}
                          errMessage={state?.errMessage}
                        />
                      </div>
                      <div className="modal-footer alert-btn">
                        <button type="btn" className="alert-clos" onClick={goNext}>
                          확인
                        </button>
                        <button type="btn" className="alert-clos" onClick={() => props.showPwdPopup(false, null)}>
                          취소
                        </button>
                      </div>
                  </div>
                </div>
              </React.Fragment>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    showPwdPopup: state.auth.showPwdPopup,
    requestType: state.auth.requestType,
    value: state.auth.value,
  }
}
const actionCreators = {
  showPwdPopup: authActions.showPwdPopup,
  checkPwd: authActions.checkPwd,
}

export default connect(mapStateToProps, actionCreators)(PasswordConfirmModal)
